import { Production } from '../../pages/ProductionPage';
import UnderConstructionPage from '../../underconstruction-page';
import {
  DailyProduction,
  CreateDailyProduction,
} from '../../pages/ProductionPage/dailyProductionRotor';
import {
  DailyProductionStrokes,
  CreateDailyProductionStrokes,
} from '../../pages/ProductionPage/dailyProductionStrokes';
import {
  DailyProductionRedBin,
  CreateDailyProductionRedBin,
} from '../../pages/ProductionPage/dailyProductionRedBin';
import {
  HourlyProductionReportList,
  CreateHourlyProductionReport,
} from '../../pages/ProductionPage/HourlyProductionReport';

import {
  DailyRejectionRotorList,
  CreateDailyRejectionRotor,
} from '../../pages/ProductionPage/dailyProductionRotorDailyRejection';

export const productions = [
  {
    path: 'production',
    element: <Production />,
  },
  {
    path: 'dailyProductionList',
    element: <DailyProduction />,
  },

  // daily prod press shop report report
  {
    path: 'production/pressShop/dailyProductionList',
    element: <DailyProduction />,
  },
  {
    path: 'production/pressShop/createEditDailyProduction/:id?',
    element: <CreateDailyProduction />,
  },

  // // daily rotor rejection report
  // {
  //   path: 'rotorSection/dailyProductionRotorDailyRejectionList',
  //   element: <DailyRejectionRotorList />,
  // },
  // {
  //   path: 'createEditDailyProductionRotorDailyRejection/:id?',
  //   element: <CreateDailyRejectionRotor />,
  // },
  // // daily production redbin list
  // {
  //   path: 'rotorSection/dailyProductionRedBinList',
  //   element: <DailyRejectionRotorList />,
  // },
  // {
  //   path: 'createEditDailyProductionRotorDailyRejection/:id?',
  //   element: <CreateDailyRejectionRotor />,
  // },

  // // hourly report
  // {
  //   path: 'pdc/rotorHourlyProductionList',
  //   element: <HourlyProductionReportList />,
  // },
  // {
  //   path: 'createHourlyProductionReports/:id?',
  //   element: <CreateHourlyProductionReport />,
  // },

  // // dailyprod strokes
  // {
  //   path: 'pressShop/dailyProductionStrokesList',
  //   element: <DailyProductionStrokes />,
  // },
  // {
  //   path: 'createEditDailyProductionStrokes/:id?',
  //   element: <CreateDailyProductionStrokes />,
  // },

  // // prodRed bin
  // {
  //   path: 'pdc/dailyProductionRedBinList',
  //   element: <DailyProductionRedBin />,
  // },
  // {
  //   path: 'createEditDailyProductionRedBin/:id?',
  //   element: <CreateDailyProductionRedBin />,
  // },
];
